import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=6c559f83&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=js&"
export * from "./goodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=6c559f83&prod&lang=css&"
import style1 from "./goodsDetails.vue?vue&type=style&index=1&id=6c559f83&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c559f83",
  null
  
)

export default component.exports